import { ConfigurationTypes } from '../const/ConfigurationTypes';
import IConfiguration from '../managers/contracts/configurations/IConfiguration';
export default abstract class AbstractGameGeneralConfig implements IConfiguration {
    type: ConfigurationTypes = ConfigurationTypes.GAME;
    cleanSpineListeners: boolean = false;
    /**
        * In a future mey be we can made different states for cascade or normal game and this prop can be used to create all needed state instance
    */
    gameType: "cascade" | "normal" = "normal";

}
